import _taggedTemplateLiteral from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import React from "react";
import Styled from "styled-components";
import { text } from "@uprise/typography";
import { primary, semantic, backgrounds, extended } from "@uprise/colors";
import Icons from "@uprise/icons";
var SuccessStyle = Styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      font-family: \"Proxima Nova Semibold\";\n      padding: 12px 16px;\n      border-radius: 5px;\n      font-size: ", ";\n      font-style: normal;\n      font-stretch: normal;\n      line-height: 1.5;\n      letter-spacing: normal;\n      width: 100%;\n      text-align: ", ";\n      color: ", ";\n      background-color: ", ";\n      flex-direction: horizontal;\n"])), text.t7, function (props) {
  return props.textAlign;
}, primary.charcoal.one, extended.purple.five);
var PrimaryStyle = Styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      font-family: \"Proxima Nova Semibold\";\n      padding: 12px 16px;\n      border-radius: 5px;\n      font-size: 15px;\n      font-style: normal;\n      font-stretch: normal;\n      line-height: 1.5;\n      letter-spacing: normal;\n      width: 100%;\n      text-align: ", ";\n      color: ", ";\n      background-color: ", ";\n"])), function (props) {
  return props.textAlign;
}, extended.charcoal.one, extended.purple.five);
var ErrorStyle = Styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      font-family: \"Proxima Nova Semibold\";\n      padding: 12px 16px;\n      border-radius: 5px;\n      font-size: 15px;\n      font-style: normal;\n      font-stretch: normal;\n      line-height: 1.5;\n      letter-spacing: normal;\n      width: 100%;\n      text-align: ", ";\n      color: ", ";\n      background-color: ", ";\n"])), function (props) {
  return props.textAlign;
}, backgrounds.white, semantic.error);
var WarningStyle = Styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      font-family: \"Proxima Nova Semibold\";\n      padding: 12px 16px;\n      border-radius: 5px;\n      font-size: 15px;\n      font-style: normal;\n      font-stretch: normal;\n      line-height: 1.5;\n      letter-spacing: normal;\n      width: 100%;\n      text-align: ", ";\n      color: ", ";\n      background-color: ", ";\n"])), function (props) {
  return props.textAlign;
}, extended.charcoal.one, semantic.warning);
var Icon = Styled.img(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    vertical-align: top;\n    margin-top: 2px;\n    margin-right: 12px;\n    width: 20px;\n    height: 20px;\n"])));
export var Alert = function Alert(_ref) {
  var children = _ref.children,
      className = _ref.className,
      textAlign = _ref.textAlign,
      type = _ref.type;

  switch (type) {
    case "primary":
      return /*#__PURE__*/React.createElement(PrimaryStyle, {
        className: className,
        type: type,
        textAlign: textAlign
      }, children);

    case "success":
      return /*#__PURE__*/React.createElement(SuccessStyle, {
        className: className,
        type: type,
        textAlign: textAlign
      }, /*#__PURE__*/React.createElement(Icon, {
        src: Icons.successPurple
      }), children);

    case "warning":
      return /*#__PURE__*/React.createElement(WarningStyle, {
        className: className,
        type: type,
        textAlign: textAlign
      }, children);

    case "error":
      return /*#__PURE__*/React.createElement(ErrorStyle, {
        className: className,
        type: type,
        textAlign: textAlign
      }, children);
  }
}; // array, bool, func, number, object, string
// symbol, node, element, elementType
// instanceOf oneOf oneOfType shape, exact, func, any

Alert.defaultProps = {
  type: "",
  textAlign: ""
};